// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"18e5aa7a","455":"84926f59","644":"b9df13b6"}[chunkId] + ".chunk.js";
};